import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { ALL_REGIONS_ID } from "../constants.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Regions/shared/RegionNames.tsx
var RegionNames = ({ regionIds }) => {
	const allRegions = regionIds.includes(ALL_REGIONS_ID);
	const { data, isCalling } = useRPC(RPCs.Regions.GetRegionsList.v1, { idFilter: regionIds }, {
		cacheStrategy: "cache-first",
		fire: !!regionIds?.length && !allRegions
	});
	if (!regionIds?.length) return null;
	if (allRegions) return /* @__PURE__ */ jsx("span", { children: "All Regions" });
	if (!data?.regions && isCalling) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 12 });
	if (!data?.regions) return null;
	return /* @__PURE__ */ jsx("span", { children: data?.regions.map((region, i) => /* @__PURE__ */ jsxs("span", { children: [region.name, i + 2 <= data?.regions.length && ", "] }, region.id)) });
};
//#endregion
export { RegionNames };

//# sourceMappingURL=RegionNames.js.map